//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClickOutside from '@/directives/ClickOutside';
import DpIcon from '../icon/Icon.vue';

export default {
  name: 'DpDrawer',
  directives: {
    ClickOutside,
  },
  components: {
    DpIcon,
  },
  props: {
    visible: { type: Boolean, default: false },
    closeText: { type: String, default: null },
  },
  watch: {
    visible(isVisible) {
      if (isVisible) {
        document.addEventListener('keyup', this.handleKeyup);
      } else {
        document.removeEventListener('keyup', this.handleKeyup);
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.handleKeyup);
  },
  methods: {
    handleKeyup(event) {
      if (event.keyCode === 27) {
        this.close();
      }
    },
    close() {
      this.$emit('close');
      this.$emit('update:visible', false);
    },
  },
};
